import { OrgRolesTab } from "@/components/shared/tab/OrgRolesTab";

export function MyOrganizationPage({ orgId, orgName }: { orgId: number; orgName: string }) {
  return (
    <div className="flex h-full flex-col overflow-hidden">
      {/* Sticky header */}
      <div className="shrink-0 shadow-sm bg-white px-3 py-4 sm:px-6">
        <div className="mx-auto max-w-6xl">
          <div>
            <h2 className="text-[28px] font-bold leading-[1.43] text-near-black">{orgName}</h2>
            <p className="text-sm text-text-secondary">Manage custom roles for your organization.</p>
          </div>
        </div>
      </div>

      {/* Scrollable body */}
      <div className="flex-1 overflow-y-auto">
        <div className="mx-auto max-w-6xl px-3 py-4 sm:px-6 sm:py-6">
          <div className="rounded-card bg-white shadow-card">
            <OrgRolesTab orgId={orgId} />
          </div>
        </div>
      </div>
    </div>
  );
}
